import React, { useEffect, useState } from 'react';
import Navbar from '../components/NavBar';
import { AnimatePresence, motion } from "framer-motion";
import { Range } from 'react-range';

import FAN_PRODUCTS from '../data/fanProducts'; // ✅ Fan ürün listesi

// Debi + tip eşleşmesi (en yakın debiden başlayarak sırala)
function matchFan({ type, flow, tolMin, tolMax, vertical, horizontal, round, rectangular }) {
  const f = Number(flow);
  if (!type || isNaN(f)) return [];

  const fMin = f * (1 + tolMin / 100);
  const fMax = f * (1 + tolMax / 100);

  return FAN_PRODUCTS
    .filter(prd => {
      if (type === 'Çatı Tipi') {
        if (!prd.type.includes('Çatı Tipi')) return false;
        if (prd.type.includes('Dikey Atışlı') && !vertical) return false;
        if (prd.type.includes('Yatay Atışlı') && !horizontal) return false;
        return prd.flow >= fMin && prd.flow <= fMax;
      }
      if (type === 'Kanal Tipi') {
        if (!prd.type.includes('Kanal Tipi')) return false;
        if (prd.type.includes('Yuvarlak') && !round) return false;
        if (prd.type.includes('Dikdörtgen') && !rectangular) return false;
        return prd.flow >= fMin && prd.flow <= fMax;
      }
      return prd.type === type && prd.flow >= fMin && prd.flow <= fMax;
    })
    .sort((a, b) => {
      const diffA = Math.abs(((a.flow - f) / f) * 100);
      const diffB = Math.abs(((b.flow - f) / f) * 100);
      return diffA - diffB;
    });
}

export default function FanQuickSelectPage() {
  const [username, setUsername] = useState('Ziyaretçi');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUsername(payload.username || 'Ziyaretçi');
      } catch {
        setUsername('Ziyaretçi');
      }
    }
  }, []);

  const [simpleType, setSimpleType] = useState('Hücreli Aspiratör');
  const [simpleFlow, setSimpleFlow] = useState('');

  // Tek slider tolerans
  const [flowTolerance, setFlowTolerance] = useState([-30, 30]);

  const [simpleMatches, setSimpleMatches] = useState([]);
  const [simpleTried, setSimpleTried] = useState(false);

  // ✅ Yeni eklenen state'ler
  const [verticalChecked, setVerticalChecked] = useState(true);
  const [horizontalChecked, setHorizontalChecked] = useState(true);
  const [roundChecked, setRoundChecked] = useState(true);
  const [rectangularChecked, setRectangularChecked] = useState(true);


  const handleSimpleFind = () => {
    setSimpleTried(true);
    const result = matchFan({
  type: simpleType,
  flow: simpleFlow,
  tolMin: flowTolerance[0],
  tolMax: flowTolerance[1],
  vertical: verticalChecked,
  horizontal: horizontalChecked,
  round: roundChecked,
  rectangular: rectangularChecked
});

    setSimpleMatches(result);
  };

  return (
    <>
      <Navbar username={username} />
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: 20 }}>
        <h1>Fan Grubu Seçimi</h1>

        {/* Arama formu */}
        <div style={{
          margin: '10px 0 20px',
          padding: 16,
          border: '1px solid #e5e7eb',
          borderRadius: 12,
          background: '#fff'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: 12,
            alignItems: 'center'
          }}>
            {/* Cihaz tipi */}
            <div>
              <label style={{ fontWeight: 600, marginBottom: 6, display: 'block' }}>Cihaz Tipi:</label>
              <select
                value={simpleType}
                onChange={(e) => setSimpleType(e.target.value)}
                style={{
                  width: '100%',
                  height: '42px',
                  padding: '0 10px',
                  border: '1px solid #ccc',
                  borderRadius: 8,
                  fontSize: '14px'
                }}
              >
                <option value="Hücreli Aspiratör">Hücreli Aspiratör</option>
                <option value="Çatı Tipi">Çatı Tipi Fan</option>
                <option value="Kanal Tipi">Kanal Tipi Fan</option>
                <option value="Duman Tahliye Fanı">Duman Tahliye Fanı</option>
                <option value="Aksiyel Fan">Aksiyel Fan</option>
              </select>
            </div>

            {/* Debi */}
            <div>
              <label style={{ fontWeight: 600, marginBottom: 6, display: 'block' }}>Hava Debisi (m³/h):</label>
              <input
                type="number"
                value={simpleFlow}
                onChange={(e) => setSimpleFlow(e.target.value)}
                placeholder="Örn: 5000"
                style={{ width: '100%', padding: 10, border: '1px solid #ccc', borderRadius: 8 }}
              />
            </div>

            {/* Debi tolerans */}
            <div>
              <label style={{ fontWeight: 600, marginBottom: 6, display: 'block' }}>Debi Tolerans:</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <input
                  type="number"
                  value={flowTolerance[0]}
                  onChange={(e) => {
                    let val = Number(e.target.value);
                    if (val > 0) val = -val;
                    setFlowTolerance([val, flowTolerance[1]]);
                  }}
                  style={{ width: 60, textAlign: 'center', border: '1px solid #ccc', borderRadius: 6 }}
                />
                <span>%</span>

                <Range
                  step={1}
                  min={0}
                  max={300}
                  values={[flowTolerance[1]]}
                  onChange={(values) => {
                    const val = values[0];
                    setFlowTolerance([-val, val]);
                  }}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      style={{
                        flex: 1,
                        height: 12,
                        background: "#ddd",
                        borderRadius: 6,
                        display: "flex",
                        alignItems: "center",
                        marginRight: "20px"
                      }}
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      {...props}
                      style={{
                        height: 24,
                        width: 24,
                        borderRadius: "50%",
                        backgroundColor: "#007bff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "white",
                        fontSize: 10,
                        fontWeight: "bold",
                        boxShadow: "0 0 4px rgba(0,0,0,0.3)"
                      }}
                    >
                      %
                    </div>
                  )}
                />

                <input
                  type="number"
                  value={flowTolerance[1]}
                  onChange={(e) => setFlowTolerance([flowTolerance[0], Number(e.target.value)])}
                  style={{ width: 60, textAlign: 'center', border: '1px solid #ccc', borderRadius: 6 }}
                />
                <span>%</span>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: '12px' }}>
            {/* Ürün Seç butonu */}
            <button
              onClick={handleSimpleFind}
              style={{
                backgroundColor: '#f97316',
                color: 'white',
                fontWeight: 700,
                border: 'none',
                borderRadius: 8,
                padding: '10px 16px',
                height: '42px', // ✅ sabit yükseklik
                cursor: 'pointer',
              }}
            >
              Ürün Seç
            </button>

            {/* Çatı Tipi Fan için ek seçenekler */}
            <AnimatePresence>
              {simpleType === 'Çatı Tipi' && (
                <motion.div
                  initial={{ opacity: 0, x: 10 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 10 }}
                  transition={{ duration: 0.3 }}
                  style={{ display: 'flex', gap: '10px' }}
                >
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '0 10px', background: '#f9fafb', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', fontSize: '14px', height: '42px', cursor: 'pointer' }}>
                    <input type="checkbox" checked={verticalChecked} onChange={(e) => setVerticalChecked(e.target.checked)} style={{ width: '16px', height: '16px', accentColor: '#f97316', cursor: 'pointer' }} />
                    <span>Dikey Atışlı</span>
                  </label>

                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '0 10px', background: '#f9fafb', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', fontSize: '14px', height: '42px', cursor: 'pointer' }}>
                    <input type="checkbox" checked={horizontalChecked} onChange={(e) => setHorizontalChecked(e.target.checked)} style={{ width: '16px', height: '16px', accentColor: '#f97316', cursor: 'pointer' }} />
                    <span>Yatay Atışlı</span>
                  </label>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Kanal Tipi Fan için ek seçenekler */}
<AnimatePresence>
  {simpleType === 'Kanal Tipi' && (
    <motion.div
      initial={{ opacity: 0, x: 10 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 10 }}
      transition={{ duration: 0.3 }}
      style={{ display: 'flex', gap: '10px' }}
    >
      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '0 10px', background: '#f9fafb', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', fontSize: '14px', height: '42px', cursor: 'pointer' }}>
        <input type="checkbox" checked={roundChecked} onChange={(e) => setRoundChecked(e.target.checked)} style={{ width: '16px', height: '16px', accentColor: '#f97316', cursor: 'pointer' }} />
        <span>Yuvarlak Kanal</span>
      </label>

      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '0 10px', background: '#f9fafb', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', fontSize: '14px', height: '42px', cursor: 'pointer' }}>
        <input type="checkbox" checked={rectangularChecked} onChange={(e) => setRectangularChecked(e.target.checked)} style={{ width: '16px', height: '16px', accentColor: '#f97316', cursor: 'pointer' }} />
        <span>Dikdörtgen Kanal</span>
      </label>
    </motion.div>
  )}
</AnimatePresence>

          </div>
        </div>

        {/* Sonuçlar */}
        {simpleTried && (
          <div style={{ marginTop: 16 }}>
            {simpleMatches.length === 0 ? (
              <div style={{
                padding: 12,
                border: '1px dashed #ccc',
                borderRadius: 8,
                color: '#475569',
                background: '#fff'
              }}>
                Uygun ürün bulunamadı. Debi toleransını veya cihaz tipini değiştirip tekrar deneyiniz.
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <AnimatePresence>
                  {simpleMatches.map((p) => (
                    <motion.div
                      key={p.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -20 }}
                      transition={{ duration: 0.3 }}
                      style={{
    display: 'flex',
    flexDirection: window.innerWidth < 768 ? 'column' : 'row',
    alignItems: window.innerWidth < 768 ? 'stretch' : 'center',
    justifyContent: window.innerWidth < 768 ? 'flex-start' : 'space-between',
    gap: '12px',
    border: '1px solid #e5e7eb',
    borderRadius: 8,
    padding: '20px 16px',
    background: '#fff',
    height: 'auto',
    width: '100%',
    boxSizing: 'border-box'
  }}
>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                        <div style={{
                          height: '100%',
                          width: '200px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <img
                            src={p.image}
                            alt={p.model}
                            style={{
                              maxHeight: '100%',
                              maxWidth: '100%',
                              objectFit: 'contain',
                              borderRadius: 8
                            }}
                          />
                        </div>
                        <div>
                          <div style={{ fontSize: 18, fontWeight: '600', lineHeight: '1.6' }}>
                            {[
                              { label: 'Marka', value: p.brand, color: '#dc2626' },
                              { label: 'Model', value: p.model, color: '#0d6efd' },
                              { label: 'Tip', value: p.type, color: '#dc2626' },
                              { label: 'Debi', value: `${p.flow.toLocaleString()} m³/h`, color: '#0d6efd' },
                            ].map((item, i) => (
                              <div key={i} style={{ display: 'flex' }}>
                                <span style={{
                                  fontWeight: '700',
                                  fontSize: 20,
                                  color: '#000',
                                  minWidth: '80px',
                                  display: 'inline-block'
                                }}>
                                  {item.label}:
                                </span>
                                <span style={{ color: item.color, marginLeft: '6px' }}>
                                  {item.value}
                                </span>
                              </div>
                            ))}
                          </div>

                          <a
                            href={p.catalog}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              marginTop: '8px',
                              display: 'inline-block',
                              fontSize: '16px',
                              fontWeight: '500',
                              color: '#007bff',
                              textDecoration: 'underline'
                            }}
                          >
                            Teknik Dökümana Buradan Ulaşabilirsiniz
                          </a>
                        </div>
                      </div>

<a
  href={`https://wa.me/905346846935?text=Merhaba,%20${p.brand} ${p.model} (${p.id})%20ürünü%20hakkında%20bilgi%20almak%20istiyorum.`}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    backgroundColor: '#25D366',
    color: '#fff',
    borderRadius: 8,
    padding: '10px 16px',
    fontWeight: 600,
    textDecoration: 'none',
    marginTop: window.innerWidth < 768 ? '12px' : '0',
    width: window.innerWidth < 768 ? '100%' : 'auto',
    boxSizing: 'border-box'   // ✅ kutu dışına taşmaz
  }}
>

                        <img
                          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                          alt="WhatsApp"
                          style={{ width: 20, height: 20 }}
                        />
                        Ürün Hakkında Bilgi Al
                      </a>
                    </motion.div>
                  ))}
                </AnimatePresence>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
